import axios, { AxiosRequestConfig } from 'axios';

/**
 * Loads the list of Countries from the server.
 * 
 * @param {bool} loadSubRegions Whether or not to load each country's sub regions.
 */
export async function fetchCountryList(loadSubRegions = false) {

    const config: AxiosRequestConfig = {
        method: 'GET',
        url: '/public/region/country-list?loadSubRegions=' + loadSubRegions,
        headers: {
            'Content-Type': 'application/json'
        }
    };

    return await axios.request(config).then((response) => {
        return response;
    }).catch((error) => {
        console.error(error);
        return error;
    });

}

/**
 * Fetches the a region by ID.
 * 
 * @param {number} regionId 
 */
export async function fetchRegion(regionId: number) {

    const config: AxiosRequestConfig = {
        method: 'GET',
        url: '/public/region/' + regionId,
        headers: {
            'Content-Type': 'application/json'
        }
    };

    return await axios.request(config).then((response) => {
        return response;
    }).catch((error) => {
        console.error(error);
        return error;
    });

}

/**
 * Validates a zip or postal code to ensure that it is in the right format for the 
 * given country.
 * 
 * @param {string} zipPostalCode 
 * @param {string} countryCode 
 */
export async function validateZipPostalCode(zipPostalCode: string, countryCode: string) {

    const config: AxiosRequestConfig = {
        method: 'GET',
        url: '/public/region/validate-zip-postal-code',
        headers: {
            'Content-Type': 'application/json'
        },
        params: {
            zipPostalCode: zipPostalCode,
            countryCode: countryCode
        }
    };

    return await axios.request(config).then((response) => {
        return response.data;
    }, (error) => {
        console.error(error);
    });

}